import dynamic from 'next/dynamic';
import { useTranslation } from '../../../lib/i18n';
import { usePageLoadBi } from '../../../lib/use-page-load-bi';
import { CategoryHeader, CategoryPage } from '../category-view/CategoryView';

// Its own chunk, fetched when the tile is opened: the home is everyone's first screen, and most visits never open it.
const CalendarScreen = dynamic(() => import('./CalendarScreen').then((m) => m.CalendarScreen), { ssr: false });

// The Calendar under the home's tiles. It counts as a Calendar view, as opening `/calendar` does, so the
// screen's use is one number whichever way the reader got there; `origin` tells the two apart.
export function HomeCalendar({ regionId }: { regionId: string }) {
  const { t } = useTranslation();
  usePageLoadBi({ page_name: 'calendar', origin: 'home' }, { pageName: 'calendar' });
  return (
    <section id={regionId} aria-label={t('calendar.title')}>
      <CategoryPage>
        <CategoryHeader title={t('calendar.title')} description={t('calendar.description')} />
        <CalendarScreen onHome />
      </CategoryPage>
    </section>
  );
}
